<template>
  <!-- key used to remove transition animation between mobile and desktop modes -->
  <div
    :key="isMobileMenu.toString()"
    class="main-sidebar"
    :class="{
      'main-sidebar--collapsed': !isMenuOpen,
      'main-sidebar--mobile': isMobileMenu,
      'main-sidebar--with-overlay': isMenuWithOverlay,
    }"
  >
    <slot
      v-if="!isMobileMenu"
      name="logo"
    />

    <tm-scrollbar
      class="main-sidebar__scroll-container"
      :scrollbar-style="scrollbarStyle ?? 'thumb-without-track-white'"
    >
      <ul class="flex-grow-1 mb-2">
        <slot />
      </ul>

      <ul
        v-if="!isMobileMenu"
        class="mb-1"
      >
        <slot name="footer">
          <main-sidebar-switcher />
        </slot>
      </ul>
    </tm-scrollbar>
  </div>
</template>

<script setup lang="ts">
import MainSidebarSwitcher from '@/components/layout/mainSidebar/MainSidebarSwitcher.vue'
import TmScrollbar from '@/components/shared/TmScrollbar.vue'
import type { ScrollbarStyle } from '@/components/shared/types'
import { useMenuState } from '@/composition/menuState'

defineProps<{
  scrollbarStyle?: ScrollbarStyle
}>()

const { isMenuOpen, isMenuWithOverlay, isMobileMenu } = useMenuState()
</script>

<style lang="scss" scoped>
@import '@/styles/mixins';

.main-sidebar {
  @include mainSidebar();

  &__scroll-container {
    scrollbar-gutter: stable;
  }

  &--with-overlay {
    @include media-lg-min {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      z-index: 25;
      overflow: hidden;
    }
  }

  &--collapsed {
    width: $sidebarCollapsedWidth;
  }

  &--mobile {
    @include mobileMenu(left);
    transform: translateX(0);
    background-image: none;
  }

  &--mobile#{&}--collapsed {
    transform: translateX(-$mobileMenuWidth);
  }
}
</style>
